<template>
  <div class="step step_2"  :class="{'form__step_hidden': step != number}" :aria-labelledby="`step${number}-title`">
    <transition-group tag="div" name="fade" class="transitiongroup" ref="transitiongroup">
      <RadioGroup :key="1" v-model="stepsdata[number][names[0]]" :name="names[0]" title="Документ, удостоверяющий личность «Страхователя»" :required="true" :values="passtypes"/>
      <p v-show="stepsdata[number][names[0]]" :key="201" class="form__text">Необходимо сделать скан или фотографию заполненных страницы паспорта и загрузить</p>
      <h3 v-show="stepsdata[number][names[0]]==passtypes[2]" :key="200" class="form__title">Перевод документа, удостоверяющего личность</h3>
      <Droparea v-show="stepsdata[number][names[0]]==passtypes[2]" :key="2" :multiple="false" :required="true" :name="names[1]" v-model="stepsdata[number][names[1]]"/>
      <h3 :key="21" v-show="stepsdata[number][names[0]]" class="form__title">Первая страница паспорта</h3>
      <Droparea :key="3" v-show="stepsdata[number][names[0]]" v-model="stepsdata[number][names[2]]" :multiple="false" :required="true" :name="names[2]"/>
      <h3 :key="22" v-show="isFilled(2)" class="form__title">Страница с регистрацией</h3>
      <Droparea :key="4" v-show="isFilled(2)" v-model="stepsdata[number][names[3]]" :multiple="false" :required="true" :name="names[3]"/>
      <h3 :key="23" v-show="isFilled(3)" class="form__title">Дополнительный файл</h3>
      <Droparea :key="5" v-show="isFilled(3)" v-model="stepsdata[number][names[4]]" :multiple="false" :required="true" :name="names[4]"/>
      <h3 :key="24" v-show="isFilled(4)" class="form__title">Дополнительный файл</h3>
      <Droparea :key="6" v-show="isFilled(4)" v-model="stepsdata[number][names[5]]" :multiple="false" :required="true" :name="names[5]"/>
    </transition-group>
    <div class="step__filler"></div>
    <div class="form__btns" ref="btns">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('prevStep')">Назад</Btn>
      <Btn @click.native.prevent="$store.commit('nextStep')" :disabled="!filled() || step != number">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from './ui/Btn.vue'
import RadioGroup from './RadioGroup.vue'
import { mapState } from 'vuex'
import Droparea from './Droparea.vue'

export default {
  data: ()=>({
    names: ['policyholderpassportdoctype', 'translatedocument', 'passportpage1', 'passportregisterpage', 'slide3additionalfile1', 'slide3additionalfile2'],
    passtypes: ['Паспорт РФ','Паспорт Белоруссии','Паспорт иностранного гражданина'],
    timer: undefined
  }),
  components: { Btn, RadioGroup, Droparea },
  props: {
    number: {type: Number, default: 2}
  },
  beforeUpdate(){
    if (this.$el.classList.contains('form__step_hidden')) return
    this.$el.style.setProperty('overflow', 'hidden')
    let height = this.$el.offsetHeight - this.getFadeHeight() + 'px'
    this.$el.style.setProperty('height', height)
    clearTimeout(this.timer)
  },
  updated(){
    this.$nextTick(()=>{
      let height = 
      [...this.$el.querySelectorAll('.transitiongroup>*:not(.fade-leave-active)')]
        .reduce((p,el)=>p + el.offsetHeight, 0)  
      + this.$el.querySelectorAll('.file_upload:not(.complete)').length * 53 
      - this.$el.querySelectorAll('.file.deleting').length * 53 
      + this.$refs.btns.offsetHeight + 'px'
      this.$el.style.setProperty('height', height)
    })
    this.timer = setTimeout(()=>{
      this.$el.style.removeProperty('height')
      this.$el.style.removeProperty('overflow')
    }, 400)
  },
  methods: {
    getFadeHeight(){
      let sum = 0
      this.$el.querySelectorAll('.fade-leave-active').forEach(el=>sum += el.offsetHeight)
      return sum
    },
    isFilled(toField){
      let base = this.stepsdata[this.number][this.names[0]] && this.stepsdata[this.number][this.names[2]]
      toField -= 2
      let count = 1
      while(toField--)
        base = base && this.stepsdata[this.number][this.names[2 + count++]]
      return base
    },
    filled(){
      for (let [i, name] of this.names.entries()) {
        if ((i == 1 && !this.isForeign) || i > 3)
          continue
        if (!this.stepsdata[this.number][name])
          return false
      }
      return  true
    }
  },
  computed: {
    ...mapState(['stepsdata','step']),
    isForeign(){
      return this.stepsdata[this.number][this.names[0]] == this.passtypes[2]
    }
  },
}
</script>

<style lang="sass">
.step .step__filler
  flex-grow: 1
  padding: 0
.step.step_2
  transition: height .4s ease-out, opacity 0.5s ease
  display: flex
  flex-direction: column
  .form__btns
    position: sticky
    bottom: 0
    z-index: 100
</style>